import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Tables from "layouts/tables";
import { useEffect, useState } from "react";
import { useGetOrdersQuery } from "slices/common/orderSlice";
import { formatDate } from "utility";
import {
  useFetchBeauticiansMutation,
  useAssignBeauticiansMutation,
} from "slices/beautyApp/beauticianSlice";
import jsPDF from "jspdf";
import { IMAGE_URL } from "network";
import "keen-slider/keen-slider.min.css";
import { useKeenSlider } from "keen-slider/react";
import VerifiedIcon from "@mui/icons-material/Verified";
import CancelIcon from "@mui/icons-material/Cancel";
import Swal from "sweetalert2";
import visaLogo from "../../../assets/images/team-2.jpg";
// import User from "./user";
import User from "../../../utility/user";
import { display } from "@mui/system";
import BookingDetailsModal from "utility/BookingOverview";
import { useUpdateBookingStatusMutation } from "slices/beautyApp/beauticianSlice";
import { Toast } from "bootstrap";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useCancelBookingMutation } from "slices/common/orderSlice";
import axios from "axios";
import {
  useRescheduleBookingMutation,
  useAddNoteMutation,
} from "slices/common/orderSlice";
import { hasActionAccess } from "utility";
import { Box, Button } from "@mui/material";
import { useSelector } from "react-redux";
import ExportCSV from "utility/exportCsv";

function Bookings() {
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);

  const [openNoteModal, setOpenNoteModal] = useState(false);
  const [noteText, setNoteText] = useState("");
  const [selectedNoteId, setSelectedNoteId] = useState(null);

  const [addNote] = useAddNoteMutation();

  const [beauticiansMap, setBeauticiansMap] = useState({});
  const [loadingBeauticianId, setLoadingBeauticianId] = useState(null);
  const [fetchBeauticians] = useFetchBeauticiansMutation();
  const [assign] = useAssignBeauticiansMutation();
  const [beauticianId, setBeauticianId] = useState(null);
  const [viewUserId, setViewUserId] = useState(null);

  const [selectedOrderId, setSelectedOrderId] = useState(null);
  const [showBeauticianModal, setShowBeauticianModal] = useState(false);
  const auth = useSelector((state) => state.auth.auth?.user);

  const [openUser, setOpenUser] = useState(null);
  const [view, setView] = useState(false);
  const [type, setType] = useState("");

  const [openBookingModal, setOpenBookingModal] = useState(false);
  const [selectedBooking, setSelectedBooking] = useState(null);
  const [UpdateBookStatus, { data: UpdateBook, isSuccess, isLoad }] =
    useUpdateBookingStatusMutation();

  const [CancelBooking] = useCancelBookingMutation();
  const [RescduleBooking] = useRescheduleBookingMutation();

  const handleViewBookingDetails = (booking) => {
    setSelectedBooking(booking);
    setOpenBookingModal(true);
  };

  const handleGenerateInvoice = (row) => {
    const doc = new jsPDF();

    doc.setFontSize(20);
    doc.setFont(undefined, "bold");
    doc.text("MadamG", 105, 20, { align: "center" });

    doc.setFontSize(10);
    doc.setFont(undefined, "normal");
    doc.text("Beauty & Wellness Services", 105, 27, { align: "center" });
    doc.text("Website: www.madamg.ai", 105, 33, { align: "center" });
    doc.text("Email: support@madamg.ai", 105, 39, { align: "center" });

    doc.line(14, 45, 196, 45);

    doc.setFontSize(12);
    doc.text(`Invoice No: ${row._id}`, 14, 55);
    doc.text(`Booking Date: ${formatDate(row.bookingDate)}`, 14, 63);
    doc.text(`Payment Status: ${row.paymentStatus}`, 14, 71);

    doc.text(
      `Assigned Beautician: ${row?.assignedBeautician?.name || "Not Assigned"}`,
      14,
      79,
    );

    doc.setFont(undefined, "bold");
    doc.text("Bill To:", 14, 90);
    doc.setFont(undefined, "normal");

    doc.text(`Name: ${row?.user?.name || "-"}`, 14, 98);
    doc.text(`Mobile: ${row?.user?.mobile || "-"}`, 14, 106);

    if (row?.address?.fullAddress) {
      doc.text(`Address: ${row.address.fullAddress}`, 14, 114, {
        maxWidth: 180,
      });
    }

    doc.line(14, 125, 196, 125);

    let y = 135;

    doc.setFont(undefined, "bold");
    doc.text("No", 14, y);
    doc.text("Service", 30, y);
    doc.text("Qty", 140, y);
    // doc.text("Price", 160, y);
    doc.setFont(undefined, "normal");

    y += 8;
    doc.line(14, y, 196, y);
    y += 8;

    row?.items?.forEach((item, index) => {
      const name = item?.itemRef?.name || "Service";
      const quantity = item.quantity || 1;
      // const price = item.itemRef.price || 0;
      doc.text(`${index + 1}`, 14, y);
      doc.text(name, 30, y, { maxWidth: 100 });
      doc.text(`${quantity}`, 140, y);
      // doc.text(`₹ ${price}`, 160, y);
      y += 8;
    });

    y += 5;
    doc.line(100, y, 196, y);
    y += 8;

    doc.text(`Subtotal:`, 120, y);
    doc.text(`₹ ${row.totalAmount || 0}`, 160, y);
    y += 8;

    doc.text(`Tax:`, 120, y);
    doc.text(`₹ ${row.tax || 0}`, 160, y);
    y += 8;

    doc.text(`Discount:`, 120, y);
    doc.text(`₹ ${row.discount || 0}`, 160, y);
    y += 8;

    doc.setFont(undefined, "bold");
    doc.text(`Grand Total:`, 120, y);
    doc.text(`₹ ${row.grandTotal || 0}`, 160, y);
    doc.setFont(undefined, "normal");

    y += 20;

    doc.setFontSize(10);
    doc.text("Thank you for choosing MadamG!", 105, y, { align: "center" });

    doc.text("This is a system generated invoice.", 105, y + 6, {
      align: "center",
    });

    doc.save(`MadamG_Invoice_${row._id}.pdf`);
  };

  const handleFindBeautician = async (orderId) => {
    try {
      setLoadingBeauticianId(orderId._id);
      const latitude =
        orderId?.address?.location?.coordinates?.[1] || 30.71697198177215;
      const longitude =
        orderId?.address?.location?.coordinates?.[0] || 76.82290544533566;
      const result = await fetchBeauticians({
        orderId: orderId._id,
        latitude,
        longitude,
        bookingDate: orderId.bookingDate,
        startTime: orderId.startTime,
        endTime: orderId.endTime,
      }).unwrap();

      if (result?.users?.length > 0) {
        setBeauticiansMap(result.users);
        setSelectedOrderId(orderId._id);
        setShowBeauticianModal(true);
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Not Found",
        text: error?.data?.message || "Beauticians not found in this area.",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "OK",
      });
      console.error("Error finding beauticians:", error);
    } finally {
      setLoadingBeauticianId(null);
    }
  };

  const { data, isLoading, refetch } = useGetOrdersQuery({
    page,
    limit,
    search,
    orderType: "beauty",
  });
  // console.log("show booking data--------------->",data);

  const assignBeautocian = async (id) => {
    try {
      let formData = { orderId: selectedOrderId, beauticianId: id };
      const result = await assign(formData).unwrap();
      if (result?.order) {
        setSelectedOrderId(null);
        setShowBeauticianModal(false);
        refetch();
      }
    } catch (error) {
      console.error("Error assigning beauticians:", error);
    }
  };

  const handleSearchChange = (value) => {
    setSearch(value);
    setPage(1);
  };

  const changePage = (newPage, newLimit) => {
    const apiPage = newPage + 1;
    setPage(apiPage);
    setLimit(newLimit);
  };

  const [sliderRef, instanceRef] = useKeenSlider({
    slides: {
      perView: 1,
      spacing: 10,
    },
    breakpoints: {
      "(min-width: 640px)": {
        slides: { perView: 3, spacing: 2 },
      },
      "(min-width: 1024px)": {
        slides: { perView: 3, spacing: 2 },
      },
    },
  });

  const getSlotsByCity = async (cityId) => {
    const res = await axios.get(
      `https://betaapi.madamg.ai/api/v1/beauty/slots/${cityId}`,
    );

    console.log("res", res);
    return res.data?.data || [];
  };

  const matchLocation = async (address) => {
    const res = await axios.post(
      `https://betaapi.madamg.ai/api/v1/location/match`,
      {
        latitude: address?.location?.coordinates[1],
        longitude: address?.location?.coordinates[0],
      },
    );
    return res?.data?.areaId;
  };

  const getWeekDayFromDate = (dateStr) =>
    new Date(dateStr)
      .toLocaleDateString("en-US", { weekday: "long" })
      .toLowerCase();

  const columns = [
    {
      display: "Booking ID",
      key: "_id",
      type: "display",
      render: (row) => (
        <span className="text-blue-200 font-medium">{row._id}</span>
      ),
      width: "180px",
    },
    {
      display: "Booking Date",
      key: "bookingDate",
      type: "display",
      render: (row) => formatDate(row.createdAt),
      // render: (row) => formatDate(row.bookingDate),
    },
    {
      display: "Appointment Date",
      key: "bookingDate",
      type: "display",
      render: (row) => formatDate(row.bookingDate),
    },
    {
      display: "Time",
      // key: "bookingDate",
      type: "display",
      render: (row) => {
        return (
          <span>{`${row.startTime ? row.startTime : "-"} - ${
            row.endTime ? row.endTime : "-"
          }`}</span>
        );
      },
    },
    // { display: "Start Time", key: "startTime", type: "display" },
    // { display: "End Time", key: "endTime", type: "display" },
    {
      display: "Note",
      key: "note",
      type: "display",
      render: (row) => (
        <div className="flex flex-col items-center">
          {row.note ? (
            <span className="text-sm text-gray-700 mb-1">
              {row.note.length > 30
                ? row.note.substring(0, 30) + "..."
                : row.note}
            </span>
          ) : (
            <span className="text-gray-400 text-sm italic">No note</span>
          )}
          &nbsp;
          <button
            className="btn btn-primary px-3 py-1 rounded text-white font-semibold bg-pink-600 hover:bg-pink-700"
            onClick={() => {
              setSelectedNoteId(row._id);
              setNoteText(row.note || "");
              setOpenNoteModal(true);
            }}
          >
            {row.note ? "Edit" : "Add"}
          </button>
        </div>
      ),
    },

    {
      display: "View Booking",
      key: "id",
      type: "display",
      render: (row) => (
        <button
          className="btn btn-primary px-3 py-1 rounded text-white font-semibold bg-pink-600 hover:bg-pink-700"
          onClick={() => handleViewBookingDetails(row)}
        >
          View
        </button>
      ),
    },

    {
      display: "Customer",
      key: "userAction",
      type: "display",
      render: (row) => {
        const user = row?.user;
        // const
        if (!user) return <span className="text-gray-400 italic">No user</span>;
        return (
          <div className="flex items-center space-x-3">
            <img
              height={"100px"}
              width={"100px"}
              src={IMAGE_URL + user.image}
              alt={user.name}
              className="w-12 h-12 rounded-full object-cover border border-gray-300 shadow"
              crossOrigin="anonymous"
            />
            <div className="d-block text-center name-details">
              {/* <span className="text-sm font-medium text-gray-800">
                {user.name}
              </span> */}
              {/* <br></br> */}
              <a
                className="btn btn-primary px-4 py-2 mt-1 rounded text-white font-semibold bg-pink-600 hover:bg-pink-700"
                onClick={(e) => {
                  e.preventDefault();
                  handleViewUserDetails(user, "user");
                }}
              >
                View
              </a>
            </div>
          </div>
        );
      },
    },

    {
      display: "Beautician",
      key: "beauticianAction",
      type: "display",
      render: (row) => {
        const isThisModalOpen =
          showBeauticianModal && selectedOrderId === row._id;
        const beautician = row?.assignedBeautician;

        const isValidBeautician =
          beautician && Object.keys(beautician).length > 0 && beautician.name;
        if (isValidBeautician) {
          return (
            <div className="flex items-center space-x-3">
              <img
                height={"100px"}
                width={"100px"}
                src={IMAGE_URL + beautician.image}
                alt={beautician.name}
                className="w-12 h-12 rounded-full object-cover border border-gray-300 shadow"
                crossOrigin="anonymous"
              />
              <div className="btn-main d-flex gap-2 justify-content-center align-items-center mt-2">
                <div className="d-block text-center name-details">
                  {/* <span className="text-sm font-medium text-gray-800">
                  {beautician.name}
                </span> */}

                  {/* <a */}
                  <button
                    // href="#"
                    className="btn btn-primary px-2 py-2 rounded text-white font-semibold bg-pink-600 hover:bg-pink-700"
                    onClick={(e) => {
                      // e.preventDefault();
                      handleViewUserDetails(beautician, "beautician");
                    }}
                  >
                    <VisibilityIcon sx={{ width: 20, height: 20 }} />
                  </button>
                </div>

                <div className="name-details">
                  <button
                    onClick={() => handleFindBeautician(row)}
                    disabled={loadingBeauticianId === row._id}
                    className={`btn btn-warning rounded text-white font-bold ${
                      loadingBeauticianId === row._id
                        ? "bg-blue-400 animate-pulse"
                        : "bg-pink-600 hover:bg-pink-700"
                    }`}
                  >
                    {loadingBeauticianId === row._id ? (
                      "Finding..."
                    ) : isThisModalOpen ? (
                      "Beauticians Found"
                    ) : (
                      <>
                        <EditIcon sx={{ width: 20, height: 20 }} />
                      </>
                    )}
                  </button>
                </div>
              </div>
            </div>
          );
        } else {
          return (
            <div className="find-b">
              <button
                onClick={() => handleFindBeautician(row)}
                disabled={loadingBeauticianId === row._id}
                className={`btn btn-warning px-4 py-2 rounded text-white font-bold ${
                  loadingBeauticianId === row._id
                    ? "bg-blue-400 animate-pulse"
                    : "bg-pink-600 hover:bg-pink-700"
                }`}
              >
                {loadingBeauticianId === row._id
                  ? "Finding..."
                  : isThisModalOpen
                  ? "Beauticians Found"
                  : "Find Beautician"}
              </button>
            </div>
          );
        }
      },
    },
    {
      display: "Contact",
      key: "Mobile",
      key2: "mobile",
      type: "display",
      render: (row) => {
        const user = row?.user;
        if (!user) return <span className="text-gray-400 italic">No user</span>;
        return <span>{user.mobile}</span>;
      },
    },

    {
      display: "Items",
      key: "items",
      type: "display",
      render: (row) => (
        <div className="space-y-1 w-full">
          {row?.items?.length > 0 ? (
            row.items.map((item, index) => {
              const name = item.itemRef?.name || "Unnamed";
              const shortName = name.split(" ").slice(0, 5).join(" ");
              const isTruncated = name.split(" ").length > 5;
              return (
                <div
                  key={index}
                  className="bg-gray-100 px-3 py-1 rounded text-sm text-gray-800 w-full box-border"
                >
                  {shortName}
                  {isTruncated ? "..." : ""} × {item.quantity}
                </div>
              );
            })
          ) : (
            <div className="text-sm text-gray-400 italic">No items found</div>
          )}
        </div>
      ),
    },

    {
      display: "Address",
      key: "address",
      key2: "fullAddress",
      type: "display",
    },

    {
      display: "Status",
      key: "orderStatus",
      type: "display",
      render: (row) => {
        const statuses = [
          "pending",
          "in-progress",
          "on-the-way",
          "arrived",
          "start-job",
          "completed",
          "cancelled",
          "re-schedule",
        ];

        const cancelNotAllowedStatuses = [
          "arrived",
          "on-the-way",
          "start-job",
          "completed",
        ];

        // 🛑 IF CANCELED → SHOW TEXT ONLY
        if (row.serviceStatus === "cancelled") {
          return (
            <div className="text-danger fw-bold">
              Cancelled
              {row.cancelReason && (
                <div className="text-xs text-gray-500 mt-1">
                  Reason: {row.cancelReason}
                </div>
              )}
            </div>
          );
        }

        const handleChangeStatus = async (event) => {
          const newStatus = event.target.value;
          if (newStatus === "cancelled") {
            const { value: reason } = await Swal.fire({
              title: "Cancel Booking",
              input: "textarea",
              inputLabel: "Reason for cancellation",
              inputPlaceholder: "Enter cancellation reason...",
              showCancelButton: true,
              confirmButtonText: "Submit",
              confirmButtonColor: "#d33",
              inputValidator: (value) =>
                !value && "Cancellation reason is required!",
            });

            if (!reason) return;

            try {
              // Uncomment when backend ready
              const res = await CancelBooking({
                id: row._id,
                status: reason,
              }).unwrap();
              Swal.fire("Cancelled!", res.message, "success");
              refetch();
            } catch (err) {
              Swal.fire(
                "Error",
                err?.data?.message || "Something went wrong!",
                "error",
              );
            }
          } else if (newStatus === "re-schedule") {
            try {
              // 1️⃣ Get location id from address
              const locid = await matchLocation(row?.address);

              if (!locid) {
                Swal.fire(
                  "Error",
                  "Unable to detect service location",
                  "error",
                );
                return;
              }

              // 2️⃣ Fetch slots by city/location
              const slotRes = await getSlotsByCity(locid);
              const weeklySlots = slotRes || [];

              if (!weeklySlots.length) {
                Swal.fire(
                  "No Slots",
                  "No slots available for this location",
                  "info",
                );
                return;
              }

              // 3️⃣ Open Reschedule Popup
              const { value: formValues } = await Swal.fire({
                title: "Reschedule Booking",
                html: `
        <label class="swal2-label">Select Date</label>
        <input
          type="date"
          id="rescheduleDate"
          class="swal2-input"
          min="${new Date().toISOString().split("T")[0]}"
        />

        <label class="swal2-label">Select Time Slot</label>
        <select id="rescheduleSlot" class="swal2-input" disabled>
          <option value="">Select date first</option>
        </select>

        <label class="swal2-label mt-2">Reschedule Reason</label>
        <textarea
          id="rescheduleReason"
          class="swal2-textarea"
          placeholder="Enter reason for rescheduling..."
        ></textarea>
      `,
                showCancelButton: true,
                confirmButtonText: "Reschedule",
                confirmButtonColor: "#3085d6",

                didOpen: () => {
                  const dateInput = document.getElementById("rescheduleDate");
                  const slotSelect = document.getElementById("rescheduleSlot");

                  dateInput.addEventListener("change", () => {
                    const selectedDate = dateInput.value;
                    const day = getWeekDayFromDate(selectedDate);

                    const dayData = weeklySlots.find(
                      (d) => d.day === day && d.active,
                    );

                    slotSelect.innerHTML = "";

                    if (!dayData || !dayData.slots?.length) {
                      slotSelect.innerHTML = `<option value="">No slots available</option>`;
                      slotSelect.disabled = true;
                      return;
                    }

                    const activeSlots = dayData.slots
                      .filter((s) => s.active)
                      .sort((a, b) => a.startMinutes - b.startMinutes);

                    slotSelect.innerHTML =
                      `<option value="">Select slot</option>` +
                      activeSlots
                        .map(
                          (slot) =>
                            `<option value="${slot.start}">
                    ${slot.start} - ${slot.end}
                  </option>`,
                        )
                        .join("");

                    slotSelect.disabled = false;
                  });
                },

                preConfirm: () => {
                  const date = document.getElementById("rescheduleDate").value;
                  const slot = document.getElementById("rescheduleSlot").value;
                  const reason = document
                    .getElementById("rescheduleReason")
                    .value.trim();

                  if (!date || !slot || !reason) {
                    Swal.showValidationMessage(
                      "Please select date, slot and enter reason",
                    );
                    return;
                  }

                  return { date, slot, reason };
                },
              });

              if (!formValues) return;

              // 4️⃣ Update booking
              const res = await RescduleBooking({
                id: row._id,
                // type: "serviceStatus",
                // status: "re-schedule",
                rescheduleDate: formValues.date,
                rescheduleSlot: formValues.slot,
                rescheduleReason: formValues.reason,
              }).unwrap();

              Swal.fire("Rescheduled!", res.message, "success");
              refetch();
            } catch (error) {
              Swal.fire(
                "Error",
                error?.message || "Failed to reschedule booking",
                "error",
              );
            }
          } else {
            try {
              const res = await UpdateBookStatus({
                id: row._id,
                type: "serviceStatus",
                status: newStatus,
              }).unwrap();

              Swal.fire("Success", res.message, "success");
              refetch();
            } catch {
              Swal.fire("Error", "Something went wrong!", "error");
            }
          }
        };

        return (
          <select
            className={`serviceStatus service-${row.serviceStatus}`}
            value={row.serviceStatus}
            onChange={handleChangeStatus}
          >
            {statuses.map((status) => {
              // ❌ Hide cancel option after certain stages
              const restrictedStatuses = ["cancelled", "re-schedule"];

              if (
                restrictedStatuses.includes(status) &&
                cancelNotAllowedStatuses.includes(row.serviceStatus)
              ) {
                return null;
              }

              return (
                <option
                  key={status}
                  value={status}
                  disabled={status === row.serviceStatus}
                >
                  {status}
                </option>
              );
            })}
          </select>
        );
      },
    },

    {
      display: "Payment",
      key: "paymentStatus",
      type: "display",
      render: (row) => {
        const paymentStatus = ["pending", "paid", "failed"];

        const handleChangeStatus = async (event) => {
          const newStatus = event.target.value;

          try {
            const res = await UpdateBookStatus({
              id: row._id,
              type: "paymentStatus",
              status: newStatus,
            }).unwrap();

            alert(res.message);
            refetch();
          } catch (err) {
            alert("Something went wrong!");
          }
        };

        return (
          <>
            <select
              className={`paymentStatus ${
                row.paymentStatus === "pending"
                  ? "paymentStatus-pending"
                  : row.paymentStatus === "paid"
                  ? "paymentStatus-paid"
                  : row.paymentStatus === "failed"
                  ? "paymentStatus-failed"
                  : ""
              }`}
              value={row.paymentStatus}
              onChange={handleChangeStatus}
            >
              {paymentStatus.map((s) => (
                <option key={s} value={s} disabled={s === row.paymentStatus}>
                  {s}
                </option>
              ))}
            </select>
          </>
        );
      },
    },
    {
      display: "Coupon Detail",
      key: "couponId",
      type: "display",
      render: (row) => {
        return (
          <>
            {row.couponId && (
              <>
                <p>
                  <b>Code:</b>
                  {row?.couponId?.code}
                </p>
                <p>
                  <b>Value:</b>
                  {`${row?.couponId?.discountValue} on ${row?.couponId?.discountType}`}
                </p>
              </>
            )}
          </>
        );
      },
    },
    { display: "Amount ", key: "totalAmount", type: "number" },
    {
      display: "Disposable Kit ",
      key: "disposableKitCharges",
      type: "number",
      color: "#cc1006",
    },
    {
      display: "Coupon Discount ",
      key: "couponDiscount",
      type: "number",
      color: "#13ed4d",
    },
    {
      display: "Instant Pay Discount ",
      key: "instantPayDiscount",
      type: "number",
      color: "#13ed4d",
    },
    {
      display: "TotalDiscount ",
      key: "discount",
      type: "number",
      color: "#39ad58",
    },
    { display: "Tax ", key: "tax", type: "number", color: "#cc1006" },

    { display: "Total Amount", key: "grandTotal", type: "number" },
    {
      display: "Invoice",
      key: "invoice",
      type: "display",
      render: (row) => (
        <button
          className="btn btn-success px-3 py-1 rounded text-white font-semibold bg-green-600 hover:bg-green-700"
          onClick={() => handleGenerateInvoice(row)}
        >
          Download
        </button>
      ),
    },
  ];

  const canEdit = hasActionAccess(auth, "Beauty App", "Bookings", "view");

  if (canEdit) {
    columns.push({
      display: "Actions",
      key: "edit",
      type: "action",
      render: (row, onEdit) => (
        <>
          {canEdit && <Button onClick={() => onView(row)}>Addon Order</Button>}
        </>
      ),
    });
  }

  const onView = async (row) => {
    if (window.confirm(`"Making connection with booking ID:", ${row._id}`)) {
      const adminToken = localStorage.getItem("adminf");

      const response = await axios.post(
        `https://betaapi.madamg.ai/api/backend/v1/auth/set-access`,
        { id: row?.user?._id, type: "booking", orderId: row._id },
        {
          headers: {
            // 'Authorization': `Bearer ${adminToken}`,
            "Content-Type": "application/json",
          },
          timeout: 30000, // 30 seconds timeout
        },
      );

      if (response.data.success) {
        const { token, user, redirectUrl } = response.data;
        console.log("Impersonation successful:", {
          token: token.substring(0, 20) + "...",
          // redirectUrl: redirect.url,
          user,
        });
        window.open(redirectUrl, "_blank");
        // window.location.href = redirectUrl;
      } else {
        throw new Error(response.data.error || "Impersonation failed");
      }
    }
  };

  console.log("data?.data", data?.data);

  const csvColumns = [
    { label: "Order Type", key: "orderType" },
    { label: "Booked By", key: "bookedBy" },
    { label: "Booking Date", key: "bookingDate" },
    { label: "Start Time", key: "startTime" },
    { label: "End Time", key: "endTime" },
    { label: "Disposable Kit Charges", key: "disposableKitCharges" },
    { label: "Grand Total", key: "grandTotal" },
    { label: "Tax", key: "tax" },
    { label: "Total", key: "totalAmount" },
    { label: "Instant Discount", key: "instantPayDiscount" },
    { label: "Order Status", key: "orderStatus" },
    { label: "Payment Method", key: "paymentMethod" },
    { label: "Payment Status", key: "paymentStatus" },
    { label: "Created At", key: "createdAt" },
  ];

  const handleViewUserDetails = (data, type) => {
    if (type === "beautician") {
      setOpenUser(data);
      setType(type);
      setView(true);
      setBeauticianId(data._id);
    } else if (type === "user") {
      setOpenUser(data);
      setType(type);
      setView(true);
      setViewUserId(data._id);
    }
  };
  const closeView = () => {
    setOpenUser(null);
    setType(null);
    setView(false);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <User
        data={openUser}
        type={type}
        id={type === "beautician" ? beauticianId : viewUserId}
        open={view}
        onClose={() => closeView()}
      />

      <Box sx={{ display: "flex", justifyContent: "flex-start", mb: 2 }}>
        <ExportCSV
          data={data?.data}
          columns={csvColumns}
          fileName="scan-report"
        />
      </Box>
      <Tables
        title="Bookings"
        handleSearch={handleSearchChange}
        totalPages={Math.ceil((data?.pagination?.total || 0) / limit)}
        data={data?.data || []}
        columns={columns}
        changePage={changePage}
        currentPage={page}
        rowsPerPage={limit}
      />
      <Footer />
      {showBeauticianModal && selectedOrderId && (
        <div
          className="modal fade show"
          tabIndex="-1"
          role="dialog"
          style={{
            display: "block",
            backgroundColor: "rgba(0,0,0,0.5)",
            zIndex: "9999",
          }}
        >
          <div
            className="modal-dialog modal-lg modal-dialog-centered select-beauty"
            role="document"
          >
            <div className="modal-content beauty-mod">
              <div className="cancle">
                <CancelIcon onClick={() => setShowBeauticianModal(false)} />
              </div>

              <div className="modal-body relative">
                {/* Keen Slider Container */}
                <div ref={sliderRef} className="keen-slider p-3">
                  {[...beauticiansMap]
                    .sort(
                      (a, b) =>
                        (b.recommended === true ? 1 : 0) -
                        (a.recommended === true ? 1 : 0),
                    )
                    .map((b, index) => (
                      <div key={index} className="keen-slider__slide px-2">
                        <div className="border rounded-xl  shadow flex flex-col items-center text-center bg-gray-50">
                          <div
                            className="select-image"
                            style={{
                              backgroundImage: `url(${visaLogo})`,
                              height: "250px",
                              width: "100%",
                              backgroundSize: "cover",
                              backgroundRepeat: "no-repeat",
                              backgroundPosition: "center",
                              backgroundBlendMode: "overlay",
                              backgroundColor: "rgb(66 66 66)",
                            }}
                          >
                            <div className="verify">
                              {b?.recommended === true && (
                                <div className="rec-title"> Recommended</div>
                              )}
                              <div>
                                <VerifiedIcon
                                  style={{ color: "white", fontSize: "48px" }}
                                />
                              </div>
                            </div>

                            <div className="select-para">
                              <p> {b?.user?.name}</p>
                              <p> {b?.user?.mobile}</p>
                            </div>

                            <img
                              height="50"
                              width="50"
                              src={IMAGE_URL + b?.user?.image}
                              alt={b?.user?.name}
                              style={{
                                width: "80px",
                                height: "80px",
                                borderRadius: "50%",
                                margin: "-38px 0 0 81px",
                                border: "3px solid white",
                              }}
                              crossOrigin="anonymous"
                              className="rounded-full object-cover border-2 border-gray-300 mb-3"
                            />
                          </div>

                          <div className="slots">
                            <div className="time">
                              <h6 className="m-0">Time Slots</h6>
                              <h6 className="m-0">Booked</h6>
                            </div>
                            <div className="dates">
                              {b?.slot?.map((item, i) => (
                                <p>
                                  {item.start} - {item.end}{" "}
                                  <span>{item.bookingCount}</span>
                                </p>
                              ))}
                            </div>
                          </div>
                          <div className="select-butn">
                            <button
                              className="mt-auto bg-blue-600 text-white px-4 py-1 text-sm rounded hover:bg-blue-700"
                              onClick={() => assignBeautocian(b?.user?._id)}
                            >
                              Select
                            </button>
                          </div>
                        </div>
                      </div>
                    ))}
                </div>

                {/* Navigation Arrows */}
                <div className="arrow-btns">
                  <button
                    onClick={() => instanceRef.current?.prev()}
                    className="absolute top-1/2 left-3 -translate-y-1/2 bg-white text-gray-700 border rounded-full w-8 h-8 flex items-center justify-center shadow hover:bg-gray-100 z-10 lgt-btn"
                  >
                    ‹
                  </button>
                  <button
                    onClick={() => instanceRef.current?.next()}
                    className="absolute top-1/2 right-3 -translate-y-1/2 bg-white text-gray-700 border rounded-full w-8 h-8 flex items-center justify-center shadow hover:bg-gray-100 z-10 rgt-btn"
                  >
                    ›
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {openNoteModal && (
        <div
          className="modal fade show"
          style={{
            display: "block",
            backgroundColor: "rgba(0,0,0,0.5)",
            zIndex: 9999,
          }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content p-4">
              <h5 className="mb-3">{noteText ? "Edit Note" : "Add Note"}</h5>

              <textarea
                className="form-control mb-3"
                rows={4}
                value={noteText}
                onChange={(e) => setNoteText(e.target.value)}
                placeholder="Enter booking note..."
              />

              <div className="d-flex justify-content-end gap-2">
                <button
                  className="btn btn-secondary"
                  onClick={() => setOpenNoteModal(false)}
                >
                  Cancel
                </button>

                <button
                  className="btn btn-primary"
                  onClick={async () => {
                    try {
                      await addNote({
                        id: selectedNoteId,
                        note: noteText,
                      }).unwrap();

                      setOpenNoteModal(false);
                      refetch();
                    } catch (err) {
                      alert("Failed to save note");
                    }
                  }}
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <BookingDetailsModal
        open={openBookingModal}
        onClose={() => setOpenBookingModal(false)}
        booking={selectedBooking}
      />
    </DashboardLayout>
  );
}

export default Bookings;
